import { render, staticRenderFns } from "./ReferraDepartment.vue?vue&type=template&id=0f57b576&scoped=true"
import script from "./ReferraDepartment.vue?vue&type=script&lang=js"
export * from "./ReferraDepartment.vue?vue&type=script&lang=js"
import style0 from "./ReferraDepartment.vue?vue&type=style&index=0&id=0f57b576&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f57b576",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f57b576')) {
      api.createRecord('0f57b576', component.options)
    } else {
      api.reload('0f57b576', component.options)
    }
    module.hot.accept("./ReferraDepartment.vue?vue&type=template&id=0f57b576&scoped=true", function () {
      api.rerender('0f57b576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/referralDepartment/ReferraDepartment.vue"
export default component.exports